var map = {
	"./images/1.5_banner.png": "D1rG",
	"./images/1.5_jianji.png": "iR0c",
	"./images/1.5_lc.png": "83M/",
	"./images/1.5_pcr.png": "TzzN",
	"./images/1.5_snp.png": "Ur2z",
	"./images/1.5_yuan.png": "Muae",
	"./images/DNA_case.png": "hGFx",
	"./images/MIX2500_1.png": "m5BE",
	"./images/MIX2500_10.png": "Qw2f",
	"./images/MIX2500_11.png": "irUt",
	"./images/MIX2500_2.png": "zM0W",
	"./images/MIX2500_3.png": "jlHz",
	"./images/MIX2500_4.png": "xWTe",
	"./images/MIX2500_5.png": "8F8s",
	"./images/MIX2500_6.png": "+ZuL",
	"./images/MIX2500_7.png": "bfX4",
	"./images/MIX2500_8.png": "p3Zl",
	"./images/MIX2500_9.png": "IvRj",
	"./images/RNA1.png": "knBd",
	"./images/RNA_1.png": "CATk",
	"./images/RNA_2.png": "ukU3",
	"./images/RNA_3.png": "Cq/I",
	"./images/T15KL_1.png": "E4WG",
	"./images/T15KL_2.png": "bdTU",
	"./images/T15KL_3.png": "Se8g",
	"./images/Virus/Adeno/banner.png": "fKNR",
	"./images/Virus/Adeno/ys.png": "q65G",
	"./images/Virus/Adeno/ys_bg.png": "OVak",
	"./images/Virus/Adenovirus/lc.png": "1cAp",
	"./images/Virus/Adenovirus/ys.png": "V101",
	"./images/Virus/Adenovirus/ys_bg.png": "ymKE",
	"./images/Virus/Lentivirus/banner.png": "QMRq",
	"./images/Virus/Lentivirus/banner_mobile.png": "vsRv",
	"./images/Virus/Lentivirus/case.png": "cFD2",
	"./images/Virus/Lentivirus/case_mobile.png": "Y84U",
	"./images/Virus/Lentivirus/lc.png": "nDpZ",
	"./images/Virus/Lentivirus/packaging01.png": "8CZ8",
	"./images/Virus/Lentivirus/packaging01_mobile.png": "ts2n",
	"./images/Virus/Lentivirus/packaging02.png": "BgMu",
	"./images/Virus/Lentivirus/packaging02_mobile.png": "AfPb",
	"./images/Virus/Lentivirus/process.png": "0UIO",
	"./images/Virus/Lentivirus/process_mobile.png": "5gMH",
	"./images/Virus/Lentivirus/ys.png": "G5J8",
	"./images/Virus/Lentivirus/ys_bg.png": "ARBh",
	"./images/Virus/Virus/banner.png": "QHG6",
	"./images/Virus/Virus/fuys_bj.png": "WUsl",
	"./images/Virus/Virus/fwys_pt.png": "Lbhi",
	"./images/akta_1.png": "JjpF",
	"./images/am096_1.png": "Wnkd",
	"./images/amplicon_1.png": "Sroz",
	"./images/amplicon_2.png": "nNFb",
	"./images/amplicon_3.png": "BPVm",
	"./images/application/background.png": "rzF8",
	"./images/application/banner01.png": "WXEQ",
	"./images/application/banner02.png": "uRBE",
	"./images/application/banner03.png": "Uytt",
	"./images/application/banner04.png": "9OX8",
	"./images/application/icon01.png": "Ui/p",
	"./images/application/icon02.png": "aYNU",
	"./images/application/icon03.png": "gnKT",
	"./images/application/icon04.png": "PDH6",
	"./images/bacterial_1.png": "LiYN",
	"./images/bacterial_2.png": "ONf5",
	"./images/bacterial_icon_1.png": "XBwi",
	"./images/bacterial_icon_2.png": "it0L",
	"./images/bacterial_icon_3.png": "iV6U",
	"./images/bacterial_icon_4.png": "01NO",
	"./images/banner_1.png": "iRaI",
	"./images/banner_10.png": "YX2f",
	"./images/banner_11.png": "GMeU",
	"./images/banner_12.png": "ZG3O",
	"./images/banner_13.png": "i8Nl",
	"./images/banner_14.png": "2H3d",
	"./images/banner_15.png": "f93W",
	"./images/banner_16.png": "II0I",
	"./images/banner_17.png": "UO9I",
	"./images/banner_18.png": "/P2F",
	"./images/banner_19.png": "tgce",
	"./images/banner_2.png": "ABKN",
	"./images/banner_3.png": "hfd9",
	"./images/banner_4.png": "A0eh",
	"./images/banner_5.png": "Kpi7",
	"./images/banner_7.png": "H7MU",
	"./images/banner_9.png": "uqOq",
	"./images/barcode_1.png": "KJef",
	"./images/barcode_2.png": "ISF8",
	"./images/barcode_3.png": "GF8X",
	"./images/barcode_4.png": "5y6j",
	"./images/broken_link.png": "tw8r",
	"./images/case.png": "O7x/",
	"./images/cell_1.png": "EBtd",
	"./images/cell_2.png": "0BSh",
	"./images/cell_3.png": "tk0G",
	"./images/cell_4.png": "JCqB",
	"./images/cell_arrow.png": "k7/C",
	"./images/circ_1.png": "hDSW",
	"./images/circ_icon_1.png": "V+/S",
	"./images/circ_icon_2.png": "LgHR",
	"./images/circ_icon_3.png": "I8kq",
	"./images/compose12_1.png": "CmbB",
	"./images/compose12_2.png": "egtQ",
	"./images/compose192_1.png": "TCgq",
	"./images/compose24_1.png": "NFv1",
	"./images/compose768_1.png": "10jb",
	"./images/compose768_11.png": "XNcV",
	"./images/compose_1.png": "c/NG",
	"./images/compose_2.png": "wKwf",
	"./images/compose_3.png": "J/8V",
	"./images/compose_3_1.png": "Y28D",
	"./images/compose_3_2.png": "UoTq",
	"./images/compose_map.png": "pxKD",
	"./images/compose_new_map.png": "r2k0",
	"./images/copy.png": "zOHj",
	"./images/denovo_icon_1.png": "dqLk",
	"./images/denovo_icon_2.png": "u8ty",
	"./images/denovo_icon_3.png": "xtxn",
	"./images/details_1.png": "21IC",
	"./images/develop_1.png": "V0gI",
	"./images/device_1.png": "BaKg",
	"./images/device_2.png": "saFn",
	"./images/device_3.png": "Jbo6",
	"./images/device_4.png": "p7Ln",
	"./images/device_5.png": "8qje",
	"./images/device_6.png": "EUe1",
	"./images/device_mini_1.png": "8TYV",
	"./images/device_mini_10.png": "hkn2",
	"./images/device_mini_2.png": "7CJK",
	"./images/device_mini_3.png": "tLsj",
	"./images/device_mini_4.png": "uWVw",
	"./images/device_mini_5.png": "yT+o",
	"./images/device_mini_6.png": "xFK/",
	"./images/device_mini_7.png": "A6dD",
	"./images/device_mini_8.png": "znDR",
	"./images/device_mini_9.png": "BJ1/",
	"./images/dna_1.png": "e6Z8",
	"./images/dna_2.png": "UYQD",
	"./images/dna_3.png": "+mi1",
	"./images/dna_icon_1.png": "vgw7",
	"./images/dna_icon_2.png": "CIuu",
	"./images/dna_icon_3.png": "VFwQ",
	"./images/dna_icon_4.png": "UVRe",
	"./images/dna_icon_5.png": "mol4",
	"./images/dna_icon_6.png": "RyTx",
	"./images/dna_icon_7.png": "zOp/",
	"./images/email_link_head.png": "bRCk",
	"./images/enLinkIcon.png": "ovMv",
	"./images/eukaryotic_1.png": "0lmg",
	"./images/extraction_1.png": "DMip",
	"./images/extraction_2.png": "v4Ww",
	"./images/failedLink.png": "/1LO",
	"./images/full_1.png": "k+0A",
	"./images/full_2.png": "DPzf",
	"./images/full_icon_2.png": "ID+1",
	"./images/fungal_1.png": "RFyK",
	"./images/fungal_2.png": "4YR2",
	"./images/gen_1.png": "t21q",
	"./images/gen_1_old.png": "/Fhj",
	"./images/gen_2.png": "RhlK",
	"./images/gen_3.png": "j5Pq",
	"./images/gen_icon_1.png": "COAF",
	"./images/gen_icon_2.png": "ucUW",
	"./images/gen_icon_3.png": "FHha",
	"./images/gen_icon_4.png": "OoXG",
	"./images/gen_icon_5.png": "BFCb",
	"./images/gen_icon_6.png": "UY38",
	"./images/gen_icon_7.png": "tmBi",
	"./images/gen_icon_8.png": "zjNB",
	"./images/gene_process.png": "0xj4",
	"./images/gene_process_mobile.png": "oW4R",
	"./images/gene_second/PCR_cloning/icon_1.png": "hKCJ",
	"./images/gene_second/PCR_cloning/icon_2.png": "rwtm",
	"./images/gene_second/PCR_cloning/icon_3.png": "pzcm",
	"./images/gene_second/PCR_cloning/process.png": "8nwM",
	"./images/gene_second/PCR_cloning/process_mobile.png": "u9bO",
	"./images/gene_second/banner.png": "zhGA",
	"./images/gene_second/banner_mobile.png": "B0ig",
	"./images/gene_second/deliverables_bg.png": "rB+7",
	"./images/gene_second/large_fragments_page/icon_1.png": "R8kr",
	"./images/gene_second/large_fragments_page/icon_2.png": "ncqK",
	"./images/gene_second/large_fragments_page/icon_3.png": "1a1r",
	"./images/gene_second/large_fragments_page/icon_4.png": "i0Dv",
	"./images/gene_second/large_fragments_page/process.png": "vdVu",
	"./images/gene_second/large_fragments_page/process_mobile.png": "UvBt",
	"./images/gene_second/mRNA_Poly_page/icon_1.png": "pvYe",
	"./images/gene_second/mRNA_Poly_page/icon_2.png": "trMS",
	"./images/gene_second/mRNA_Poly_page/icon_3.png": "rzjb",
	"./images/gene_second/pETgene_page/icon_1.png": "80B2",
	"./images/gene_second/pETgene_page/icon_2.png": "hOtI",
	"./images/gene_second/pETgene_page/icon_3.png": "QwrB",
	"./images/gene_second/pETgene_page/icon_4.png": "rRwJ",
	"./images/gene_second/rapid_page/icon_1.png": "HcDJ",
	"./images/gene_second/rapid_page/icon_2.png": "6S25",
	"./images/gene_second/standard_page/icon_1.png": "XAcf",
	"./images/gene_second/standard_page/icon_2.png": "EfjR",
	"./images/gene_second/standard_page/icon_3.png": "l1h/",
	"./images/gene_second/standard_page/icon_4.png": "lrga",
	"./images/global_1.png": "NyPd",
	"./images/hot.png": "Ix9H",
	"./images/human_1.png": "zewc",
	"./images/human_icon_1.png": "TxzC",
	"./images/human_icon_2.png": "dO6T",
	"./images/human_icon_3.png": "30RK",
	"./images/human_icon_4.png": "E35d",
	"./images/human_icon_5.png": "GNX7",
	"./images/human_icon_9.png": "hd1j",
	"./images/icon_RNA.png": "K/6t",
	"./images/icon_chart.png": "QMrb",
	"./images/icon_chart2.png": "eLgr",
	"./images/icon_chart_white.png": "zQ2m",
	"./images/icon_check3.png": "xP1T",
	"./images/icon_check3_disable.png": "y+yI",
	"./images/icon_copy.png": "758b",
	"./images/icon_copy2.png": "Qa4v",
	"./images/icon_down.png": "a4CZ",
	"./images/icon_down2.png": "yBjr",
	"./images/icon_down3.png": "hOkp",
	"./images/icon_download.png": "wqNP",
	"./images/icon_email.png": "LNbV",
	"./images/icon_miRNA.png": "ABeg",
	"./images/icon_more.png": "mYqV",
	"./images/icon_phone_primary.png": "lmSt",
	"./images/icon_search.png": "3rhe",
	"./images/icon_service_primary.png": "UB9F",
	"./images/icon_siRNA.png": "pyjb",
	"./images/icon_success.png": "JsnA",
	"./images/icon_tel.png": "Psa6",
	"./images/icon_user.png": "j8KV",
	"./images/icon_warn.png": "sboA",
	"./images/identification_1.png": "d6th",
	"./images/identification_2.png": "4dM9",
	"./images/identification_3.png": "im38",
	"./images/img_top.png": "NXDi",
	"./images/improveInformationHead.png": "Zlzd",
	"./images/inc_1.png": "TzXi",
	"./images/its_1.png": "Tk9L",
	"./images/link_failure.png": "NP4s",
	"./images/list.png": "TV/B",
	"./images/login_bg.png": "aF6v",
	"./images/logo.png": "iQH9",
	"./images/macrogenome_1.png": "rPpZ",
	"./images/macrogenome_icon_1.png": "mU/w",
	"./images/macrogenome_icon_2.png": "95oN",
	"./images/macrogenome_icon_3.png": "iBEB",
	"./images/macrogenome_icon_4.png": "LrpJ",
	"./images/macrogenome_icon_5.png": "WQ5b",
	"./images/macrogenome_icon_6.png": "kw93",
	"./images/mc15k_1.png": "2cQ/",
	"./images/metal_1.png": "q+Vc",
	"./images/metal_2.png": "HVsR",
	"./images/metal_3.png": "X2KV",
	"./images/metal_4.png": "lICC",
	"./images/metal_5.png": "dEIO",
	"./images/metal_6.png": "O2y/",
	"./images/metal_7.png": "4pe3",
	"./images/metal_8.png": "5Us/",
	"./images/metal_9.png": "Hy50",
	"./images/mini7ks_1.png": "XtKU",
	"./images/mini_1.png": "kukf",
	"./images/mitochondrial_1.png": "6mBp",
	"./images/mobile/arrow.png": "kMgV",
	"./images/mobile/arrow_down.png": "j+dE",
	"./images/mobile/bg_primary.png": "s/R1",
	"./images/mobile/bg_red.png": "d2zu",
	"./images/mobile/empty.png": "wCtS",
	"./images/mobile/icon_back.png": "Bwel",
	"./images/mobile/icon_car.png": "QdAR",
	"./images/mobile/icon_code.png": "/6DE",
	"./images/mobile/icon_compose.png": "gXRl",
	"./images/mobile/icon_gene.png": "shmb",
	"./images/mobile/icon_ing.png": "4joE",
	"./images/mobile/icon_integral.png": "hIqd",
	"./images/mobile/icon_lock.png": "aMAz",
	"./images/mobile/icon_molecular.png": "UBXn",
	"./images/mobile/icon_ok.png": "5Yah",
	"./images/mobile/icon_other.png": "MhNP",
	"./images/mobile/icon_phone.png": "osyB",
	"./images/mobile/icon_phone2.png": "85Oc",
	"./images/mobile/icon_search.png": "Qo0D",
	"./images/mobile/icon_status_1.png": "aJWP",
	"./images/mobile/icon_stauts_2.png": "9Dp6",
	"./images/mobile/icon_success.png": "79eE",
	"./images/mobile/icon_sunger.png": "5wrG",
	"./images/mobile/icon_time.png": "Shc/",
	"./images/mobile/icon_user.png": "0VzF",
	"./images/mobile/icon_user2.png": "g32T",
	"./images/mobile/icon_wait.png": "riWg",
	"./images/mobile/logo.png": "KoaG",
	"./images/mobile/logo_2.png": "xjxK",
	"./images/mobile/status_bg_ing.png": "3gSY",
	"./images/mobile/status_part.png": "yrsM",
	"./images/mobile/sunger_banner.png": "YEum",
	"./images/mobile/top_bg.png": "91Xn",
	"./images/mp2500_1.png": "v1Vv",
	"./images/new.png": "X10k",
	"./images/news_1.png": "jMto",
	"./images/ngs_second/transcriptome/lncRNA/icon_1.png": "vTyk",
	"./images/ngs_second/transcriptome/lncRNA/icon_2.png": "T77L",
	"./images/ngs_second/transcriptome/lncRNA/icon_3.png": "IDAV",
	"./images/ngs_second/transcriptome/lncRNA/icon_4.png": "di5Q",
	"./images/ngs_second/transcriptome/lncRNA/icon_5.png": "3giI",
	"./images/ngs_second/transcriptome/prokaryotic/icon_1.png": "mpeY",
	"./images/ngs_second/transcriptome/prokaryotic/icon_2.png": "Yg+y",
	"./images/ngs_second/transcriptome/prokaryotic/icon_3.png": "vjA4",
	"./images/ngs_second/transcriptome/prokaryotic/prokaryotic_1.png": "pgIH",
	"./images/ngs_second/transcriptome/sequencing/result_1.png": "OpM7",
	"./images/ngs_second/transcriptome/sequencing/result_2.png": "qZPM",
	"./images/ngs_second/transcriptome/sequencing/result_3.png": "cd1b",
	"./images/ngs_second/transcriptome/sequencing/result_4.png": "EzQe",
	"./images/ngs_second/transcriptome/sequencing/result_5.png": "w2Hd",
	"./images/ngs_second/transcriptome/sequencing/result_6.png": "ijA1",
	"./images/ngs_second/transcriptome/sequencing/workflow_1.png": "eDgI",
	"./images/ngs_second/transcriptome/smallRNA/icon_1.png": "u2Cq",
	"./images/ngs_second/transcriptome/smallRNA/icon_2.png": "zngX",
	"./images/ngs_second/transcriptome/smallRNA/icon_3.png": "s56H",
	"./images/ngs_second/transcriptome/smallRNA/icon_4.png": "5l5K",
	"./images/ngs_second/transcriptome/smallRNA/icon_5.png": "1m1X",
	"./images/ngs_second/transcriptome/smallRNA/icon_6.png": "a3QI",
	"./images/ngs_second/transcriptome/whole_transciptome/icon_1.png": "Bajq",
	"./images/ngs_second/transcriptome/whole_transciptome/icon_2.png": "buX9",
	"./images/ngs_second/transcriptome/whole_transciptome/icon_3.png": "f542",
	"./images/ngs_second/transcriptome/whole_transciptome/icon_4.png": "57q9",
	"./images/ngs_second/transcriptome/whole_transciptome/icon_5.png": "FfTA",
	"./images/ngs_second/transcriptome/whole_transciptome/icon_6.png": "fWNT",
	"./images/ngs_second/transcriptome/whole_transciptome/icon_7.png": "WUaC",
	"./images/ngs_second/transcriptome/whole_transciptome/icon_8.png": "tq19",
	"./images/order_bg.png": "KOb7",
	"./images/pcr_4.png": "phbX",
	"./images/primer_service_1.png": "CmjO",
	"./images/product_1.png": "UNxw",
	"./images/product_2.png": "CYWt",
	"./images/product_3.png": "e6SX",
	"./images/profile_1.png": "6luH",
	"./images/prokaryotic_icon_1.png": "bZbO",
	"./images/prokaryotic_icon_4.png": "uWAX",
	"./images/prokaryotic_icon_5.png": "dtPg",
	"./images/prokaryotic_icon_6.png": "bFGW",
	"./images/prokaryotic_icon_7.png": "2OM1",
	"./images/prokaryotic_icon_8.png": "Of4F",
	"./images/qpcr_1.png": "BWhj",
	"./images/qpcr_2.png": "B+gL",
	"./images/qpcr_3.png": "A+Ku",
	"./images/qpcr_4.png": "fz2t",
	"./images/qpcr_5.png": "+2xm",
	"./images/qpcr_6.png": "AyIx",
	"./images/qpcr_7.png": "0lft",
	"./images/qpcr_8.png": "yAdQ",
	"./images/qrcode.png": "/4D4",
	"./images/quit.png": "4dWG",
	"./images/r01_1.png": "OZ2T",
	"./images/rdna_1.png": "l6nN",
	"./images/rdna_2.png": "G/FD",
	"./images/rdna_4.png": "j/u0",
	"./images/resequencing_1.png": "bfjJ",
	"./images/resequencing_2.png": "8x5q",
	"./images/resequencing_icon_1.png": "8jMk",
	"./images/resequencing_icon_2.png": "KQ3g",
	"./images/resequencing_icon_3.png": "2p3g",
	"./images/resequencing_icon_4.png": "pE0G",
	"./images/resequencing_icon_5.png": "FKYj",
	"./images/resequencing_icon_6.png": "1aOC",
	"./images/rt20_1.png": "XibP",
	"./images/sanger_1.png": "pBSu",
	"./images/sanger_2.png": "m1rs",
	"./images/sanger_2_old.png": "nlbP",
	"./images/sanger_icon1.png": "f6Uy",
	"./images/sanger_icon1_active.png": "qjIb",
	"./images/sanger_icon2.png": "Gxdb",
	"./images/sanger_icon2_active.png": "mwBe",
	"./images/sanger_icon3.png": "TCCI",
	"./images/sanger_icon3_active.png": "HnZN",
	"./images/sanger_service_1.png": "MDHf",
	"./images/sanger_service_1_old.png": "EjVT",
	"./images/sanger_service_2.png": "ASJr",
	"./images/sanger_service_2_old.png": "0al7",
	"./images/sanger_service_3.png": "/BtA",
	"./images/sanger_service_3_old.png": "4+O4",
	"./images/sanger_service_4.png": "5526",
	"./images/sanger_service_4_old.png": "OLCy",
	"./images/save_icon_1.png": "LJke",
	"./images/save_icon_2.png": "hvK7",
	"./images/save_icon_3.png": "c4ah",
	"./images/save_icon_4.png": "12kt",
	"./images/save_icon_5.png": "HWn1",
	"./images/service_icon_1.png": "KZuH",
	"./images/service_icon_2.png": "YvKy",
	"./images/small_1.png": "ewMN",
	"./images/snp_1.png": "YyBL",
	"./images/snp_2.png": "byFk",
	"./images/snp_3.png": "Zr93",
	"./images/snp_4.png": "B3Cj",
	"./images/snp_5.png": "naF0",
	"./images/snp_6.png": "FegY",
	"./images/snp_7.png": "1jnz",
	"./images/snp_service_1.png": "q8su",
	"./images/snp_service_2.png": "bEPG",
	"./images/snp_service_3.png": "5RJr",
	"./images/snp_service_4.png": "9j/5",
	"./images/snp_service_5.png": "4fBK",
	"./images/specific_1.png": "elGe",
	"./images/specific_4.png": "iCf4",
	"./images/specific_5.png": "V1Mm",
	"./images/specific_6.png": "mMGu",
	"./images/specific_7.png": "lPPz",
	"./images/ssr_2.png": "MVQA",
	"./images/ssr_3.png": "2wFP",
	"./images/ssr_4.png": "Oo99",
	"./images/ssr_5.png": "ARhQ",
	"./images/ssr_6.png": "XInv",
	"./images/ssr_7.png": "gGwy",
	"./images/ssr_8.png": "j8o/",
	"./images/ssr_9.png": "Q/r6",
	"./images/ssr_service_1.png": "e4Q1",
	"./images/ssr_service_2.png": "Scau",
	"./images/ssr_service_3.png": "qphm",
	"./images/target_1.png": "9E1Z",
	"./images/target_icon_1.png": "G0Np",
	"./images/target_icon_2.png": "dqZ5",
	"./images/target_icon_3.png": "jOca",
	"./images/target_icon_4.png": "0kHF",
	"./images/target_icon_5.png": "ix9s",
	"./images/tm30_1.png": "WGbe",
	"./images/tools/arrowhead.png": "EjSa",
	"./images/tools/download_file_icon_black.png": "ubxI",
	"./images/tools/download_file_icon_blue.png": "WFSP",
	"./images/tools/download_file_icon_white.png": "8wwv",
	"./images/tools/drag_upload_icon.png": "+ZwK",
	"./images/tools/forward_corner.png": "zCxH",
	"./images/tools/forward_icon.png": "4RWF",
	"./images/tools/reverse_corner.png": "Q8Bb",
	"./images/tools/reverse_icon.png": "9IQt",
	"./images/tools/triangle.png": "eGeB",
	"./images/vector_1.png": "XGdt",
	"./images/vector_2.png": "5ljN",
	"./images/wh5_1.png": "lbM+",
	"./images/whole_1.png": "+3cI",
	"./images/whole_3.png": "8UEr",
	"./images/whole_icon_5.png": "DdBZ",
	"./images/whole_icon_6.png": "ODAH",
	"./images/zl_bg.png": "u/2f",
	"./images/zl_keji.png": "kezA",
	"./images/zl_yy1.png": "8sIN",
	"./images/zl_yy2.png": "pLC9",
	"./images/zl_yy3.png": "SXI0",
	"./images/zx.png": "d4MG",
	"./img/Virus/Adeno/banner.png": "KLmn",
	"./img/Virus/Adeno/ys.png": "jdgb",
	"./img/Virus/Adeno/ys_bg.png": "F9pO",
	"./img/Virus/Adenovirus/Adeno_associated_virus.png": "oAVV",
	"./img/Virus/Adenovirus/banner.png": "4it+",
	"./img/Virus/Adenovirus/bannerNew.png": "hY30",
	"./img/Virus/Adenovirus/case.png": "NKLE",
	"./img/Virus/Adenovirus/case1.png": "ILr/",
	"./img/Virus/Adenovirus/case2.png": "+4Cc",
	"./img/Virus/Adenovirus/case3.png": "Sgut",
	"./img/Virus/Adenovirus/case4.png": "INKe",
	"./img/Virus/Adenovirus/case5.png": "3aBI",
	"./img/Virus/Adenovirus/case6.png": "716H",
	"./img/Virus/Adenovirus/lc.png": "DNsF",
	"./img/Virus/Adenovirus/lc_2.png": "QXQT",
	"./img/Virus/Adenovirus/lc_new.png": "2SfQ",
	"./img/Virus/Adenovirus/package.png": "zK26",
	"./img/Virus/Adenovirus/ys.png": "jm0P",
	"./img/Virus/Adenovirus/ys_bg.png": "LpSX",
	"./img/Virus/Lentivirus/banner.png": "p0I+",
	"./img/Virus/Lentivirus/lc.png": "ysUa",
	"./img/Virus/Lentivirus/lc_2.png": "RfnW",
	"./img/Virus/Lentivirus/ys.png": "MnAb",
	"./img/Virus/Lentivirus/ys_bg.png": "QlJd",
	"./img/Virus/Virus/banner.png": "upoi",
	"./img/Virus/Virus/bannerNew.png": "VU7J",
	"./img/Virus/Virus/fuys_bj.png": "1VQt",
	"./img/Virus/Virus/fwys_pt.png": "Zr0l",
	"./img/Virus/Virus/service-process.png": "OBgT",
	"./img/adress.png": "hiXM",
	"./img/biology.png": "sP11",
	"./img/carts/1.png": "5qmW",
	"./img/carts/2.png": "t5dA",
	"./img/carts/3.png": "l2VO",
	"./img/carts/4.png": "zJxu",
	"./img/carts/5.png": "pZxs",
	"./img/carts/6.png": "5PpP",
	"./img/carts/7.png": "KdWq",
	"./img/carts/mark.png": "p5wM",
	"./img/carts/mark1.png": "IGc6",
	"./img/carts/mark2.png": "MP2U",
	"./img/coupon-disabled.png": "hjmb",
	"./img/coupon.png": "NXC6",
	"./img/coupon1.png": "wINw",
	"./img/dalou.png": "/Ntc",
	"./img/denglu.png": "xaeX",
	"./img/developmentHistory.png": "RF3d",
	"./img/developmentHistoryOld.png": "QXXS",
	"./img/dina.png": "8hu4",
	"./img/email.png": "maZZ",
	"./img/fenzi.png": "HzBk",
	"./img/fenzi1.png": "3Eys",
	"./img/gene.png": "GMsg",
	"./img/gene_factory/banner.png": "9T0w",
	"./img/gene_factory/main.png": "O+R/",
	"./img/icon_arrow_right.png": "Olyi",
	"./img/icon_radio.png": "CdnO",
	"./img/icon_radio_checked.png": "g9il",
	"./img/ipone.png": "D0qF",
	"./img/iso/1.png": "WLtL",
	"./img/iso/2.png": "frjb",
	"./img/jianjie.png": "3yC2",
	"./img/jiantou.png": "93Nf",
	"./img/join_us.png": "6jAH",
	"./img/life.png": "l4eF",
	"./img/logoN.png": "K/hx",
	"./img/lx.png": "0/vd",
	"./img/new_lx.png": "RT0b",
	"./img/news.png": "wPT4",
	"./img/products/recombinant-cells-protein-expression/advantage.png": "yILA",
	"./img/products/recombinant-cells-protein-expression/cover-old.png": "XfgU",
	"./img/products/recombinant-cells-protein-expression/cover.png": "uOKS",
	"./img/qk.png": "gk7A",
	"./img/qrcode.png": "cgBV",
	"./img/resource.png": "qOWL",
	"./img/serviceAdvantages.png": "V1z0",
	"./img/share/auth/card_bg.png": "BLcW",
	"./img/share/auth/logo.png": "V4RJ",
	"./img/share/confirm/customer.png": "HIOG",
	"./img/share/confirm/order.png": "m3Wt",
	"./img/share/order/address_icon.png": "lLhL",
	"./img/share/order/status_bg.png": "5Xxn",
	"./img/share/order/status_icon.png": "hamQ",
	"./img/xiaojiejie.png": "V72r",
	"./img/zixi.png": "KYHP",
	"./img/zx.png": "iy76",
	"./img/产品及服务/1.5代测序/1.5_banner.png": "0wpD",
	"./img/产品及服务/1.5代测序/1.5_jianji.png": "RLgn",
	"./img/产品及服务/1.5代测序/1.5_lc.png": "Xsj9",
	"./img/产品及服务/1.5代测序/1.5_pcr.png": "M1kj",
	"./img/产品及服务/1.5代测序/1.5_snp.png": "twU+",
	"./img/产品及服务/1.5代测序/1.5_yuan.png": "PU7c",
	"./img/产品及服务/1.5代测序/banner.png": "t5YP",
	"./img/产品及服务/1.5代测序/bg.png": "IO6k",
	"./img/产品及服务/BSP_Sequencing/img1.png": "f7sx",
	"./img/产品及服务/BSP_Sequencing/img2.png": "v79d",
	"./img/产品及服务/BSP_Sequencing/img3.png": "FSMY",
	"./img/产品及服务/BSP_Sequencing/img4.png": "U7x9",
	"./img/产品及服务/BSP_Sequencing/img4_mo.png": "25NL",
	"./img/产品及服务/DNA提取+PCR扩增+测序/banner.png": "VlKX",
	"./img/产品及服务/DNA提取+PCR扩增+测序/应用案例.png": "x+M/",
	"./img/产品及服务/DNA提取+PCR扩增+测序/服务流程.png": "I9oS",
	"./img/产品及服务/T载体克隆/banner.png": "RVyi",
	"./img/产品及服务/T载体克隆/ys.png": "Otqm",
	"./img/产品及服务/T载体克隆/ys_bg.png": "XOva",
	"./img/产品及服务/T载体克隆/服务流程.png": "6ben",
	"./img/产品及服务/service-flow-circRNA.png": "pCA/",
	"./img/产品及服务/全基因组合成/定点突变/1.png": "+ie/",
	"./img/产品及服务/全基因组合成/定点突变/1_2.png": "yqqE",
	"./img/产品及服务/合成基因组学产品及服务/bg.png": "LiVA",
	"./img/产品及服务/合成基因组学产品及服务/bg1.png": "dCZE",
	"./img/产品及服务/合成基因组学产品及服务/bg2.png": "stz/",
	"./img/产品及服务/合成基因组学产品及服务/huaxue.png": "AHoU",
	"./img/产品及服务/合成基因组学产品及服务/jiankang.png": "4hyB",
	"./img/产品及服务/合成基因组学产品及服务/jieneng.png": "7VKJ",
	"./img/产品及服务/合成基因组学产品及服务/shiwu.png": "3Aah",
	"./img/产品及服务/基因检测/banner.png": "+/HE",
	"./img/产品及服务/基因检测/bg.png": "8+WF",
	"./img/产品及服务/基因检测/bg1.png": "X2b+",
	"./img/产品及服务/基因组测序/banner.png": "jZaW",
	"./img/产品及服务/基因组测序/ys.png": "BI9o",
	"./img/产品及服务/基因编辑/banner.png": "lB1p",
	"./img/产品及服务/基因调控/banner.png": "kg0t",
	"./img/产品及服务/基因调控/ct.png": "p7iD",
	"./img/产品及服务/基因调控/ct_2.png": "DMZT",
	"./img/产品及服务/基因调控/sgRNA.png": "jvfk",
	"./img/产品及服务/基因调控/sgRNA_2.png": "uPpQ",
	"./img/产品及服务/基因调控/基因干扰/banner.png": "TLsA",
	"./img/产品及服务/基因调控/基因干扰/gene_interference_flow.png": "1egj",
	"./img/产品及服务/基因调控/基因干扰/ys.png": "7zI/",
	"./img/产品及服务/基因调控/基因干扰/ys_bj.png": "ZxLa",
	"./img/产品及服务/基因调控/基因检测panel定制及SNP分型/banner.png": "HZS0",
	"./img/产品及服务/基因调控/基因编辑/CRISPRa.png": "Q0Cv",
	"./img/产品及服务/基因调控/基因编辑/CRISPRa_2.png": "SYYq",
	"./img/产品及服务/基因调控/基因编辑/banner.png": "vTvX",
	"./img/产品及服务/基因调控/基因编辑/critle.png": "ccrc",
	"./img/产品及服务/基因调控/基因编辑/fw.png": "Pn6o",
	"./img/产品及服务/基因调控/基因编辑/yl.png": "/MzM",
	"./img/产品及服务/基因调控/基因编辑/ys.png": "RF4U",
	"./img/产品及服务/基因调控/基因编辑/ys_bg.png": "kpbP",
	"./img/产品及服务/基因调控/甲基化检测/banner.png": "Rmuc",
	"./img/产品及服务/基因调控/蛋白表达/banner.png": "svus",
	"./img/产品及服务/基因调控/蛋白表达/ys.png": "AOto",
	"./img/产品及服务/基因调控/蛋白表达/ys_bg.png": "vtqZ",
	"./img/产品及服务/常规分子项目/banner.png": "NPv2",
	"./img/产品及服务/微生物测序/banner.png": "8XE1",
	"./img/产品及服务/微生物测序/ys.png": "Khco",
	"./img/产品及服务/细胞株构建/banner.png": "Fyhb",
	"./img/产品及服务/细胞株构建/case-img.png": "o7u2",
	"./img/产品及服务/细胞株构建/service-advantage-img.png": "RAt2",
	"./img/产品及服务/细胞株构建/service-process.png": "9FpC",
	"./img/产品及服务/转录组测序/banner.png": "FjPH",
	"./img/产品及服务/转录组测序/ys.png": "jhq0",
	"./img/活动图-02.png": "OfTJ",
	"./img/活动图-03.png": "Fkjj",
	"./img/活动图_画板 1.png": "Avzi",
	"./img/生物制造/banner.png": "ex8J",
	"./img/生物制造/插图.png": "W04W",
	"./img/设备及原料/仪器设备/12合成仪.png": "Pvsu",
	"./img/设备及原料/仪器设备/768合成仪-1.png": "KMbC",
	"./img/设备及原料/仪器设备/768纯化仪.png": "XfuJ",
	"./img/设备及原料/仪器设备/banner.png": "43PQ",
	"./img/设备及原料/仪器设备/ys.png": "fahS",
	"./img/设备及原料/仪器设备/插图.png": "qmng",
	"./img/设备及原料/仪器设备/插图_2.png": "vdGT",
	"./img/设备及原料/仪器设备/氨解仪.png": "okfz",
	"./img/设备及原料/仪器设备/氨解仪/yiqi1.png": "eIBG",
	"./img/设备及原料/仪器设备/氨解仪/yiqi2.png": "JqIy",
	"./img/设备及原料/仪器设备/氨解仪/氨解仪.png": "f8Pp",
	"./img/设备及原料/仪器设备/氨解仪/氨解仪展示1.png": "h18g",
	"./img/设备及原料/仪器设备/氨解仪/氨解仪展示2.png": "GfAT",
	"./img/设备及原料/仪器设备/氨解仪/氨解仪整体展示.png": "bwmT",
	"./img/设备及原料/仪器设备/氨解仪/电源.png": "Ydot",
	"./img/设备及原料/仪器设备/氨解仪/空气清洁.png": "swtX",
	"./img/设备及原料/仪器设备/氨解仪/通风.png": "RNxN",
	"./img/设备及原料/仪器设备/溶解仪.png": "dIDy",
	"./img/设备及原料/仪器设备/离心浓缩仪.png": "DVJF",
	"./img/设备及原料/仪器设备/除湿系统.png": "0kC1",
	"./img/设备及原料/修饰合成/banner.png": "FT05",
	"./img/设备及原料/修饰合成/ys.png": "5zSd",
	"./img/设备及原料/修饰合成/修饰引物合成/GMP.png": "RTb6",
	"./img/设备及原料/修饰合成/修饰引物合成/banner1.png": "O7Cj",
	"./img/设备及原料/修饰合成/修饰引物合成/qualified.png": "Jw7A",
	"./img/设备及原料/修饰合成/修饰引物合成/定制化.png": "+uHa",
	"./img/设备及原料/修饰合成/修饰引物合成/批间差.png": "rv/7",
	"./img/设备及原料/修饰合成/修饰引物合成/营销网络.png": "e4DA",
	"./img/设备及原料/修饰合成/修饰引物合成/质控数据.png": "B382",
	"./img/设备及原料/修饰合成/修饰引物合成/质量体系.png": "rNdS",
	"./img/设备及原料/修饰合成/修饰引物合成/质量保证.png": "zsi7",
	"./img/设备及原料/化学试剂/banner.png": "JBMB",
	"./img/设备及原料/化学试剂/h_1.png": "xQeK",
	"./img/设备及原料/化学试剂/h_2.png": "YhG7",
	"./img/设备及原料/化学试剂/h_3.png": "fjau",
	"./img/设备及原料/化学试剂/h_4.png": "jHrp",
	"./img/设备及原料/化学试剂/h_5.png": "/A2n",
	"./img/设备及原料/化学试剂/xuan.png": "4fQb",
	"./img/设备及原料/化学试剂/ys.png": "gvTi",
	"./img/设备及原料/合成技术整体解决方案/advantage.png": "dl/L",
	"./img/设备及原料/合成技术整体解决方案/advantage1.png": "nOAq",
	"./img/设备及原料/合成技术整体解决方案/banner.png": "VHKl",
	"./img/设备及原料/合成技术整体解决方案/banner1.png": "1voP",
	"./img/设备及原料/合成技术整体解决方案/flow.png": "xcge",
	"./img/设备及原料/生命科学研究设备及原料/banner.png": "lGzI",
	"./img/设备及原料/生命科学研究设备及原料/ys.png": "Bu1U",
	"./img/设备及原料/生命科学研究设备及原料/ys_2.png": "S3r/",
	"./img/设备及原料/生物试剂/Daling_banner.png": "GkGY",
	"./img/设备及原料/生物试剂/banner.png": "Nu9y",
	"./img/首页-公司展示.png": "g1Hj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 16